// @ts-check
import * as React from "react"
import {useStaticQuery, graphql} from "gatsby"

import Layout from "../components/layout"

/**
 * @param {{
 *  children: React.ReactNode
 *  pageProps: import("gatsby").PageProps
 * }} wrapElementParams
 * @returns
 */
const LayoutContainer = ({children, pageProps}) => {
  /**
   * @type {{
   *   strapiGlobal: import('../data/global').Global
   * }}
   */
  const {strapiGlobal} = useStaticQuery(graphql`
    query {
      strapiGlobal {
        ...GlobalData
      }
    }
  `)

  return (
    <Layout {...pageProps} globalData={strapiGlobal}>
      {children}
    </Layout>
  )
}

export default LayoutContainer

export const query = graphql`
  fragment GlobalData on STRAPI_GLOBAL {
    author
    siteTitle
    siteDescription
    contactEmail
    contactPhone
    contactLocation
    contents {
      ...StrapiContent
    }
  }
`
